import { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import type {
  TCreateReferralCommissionRequest,
  TGetReferralCommissionRequest,
  TGetReferralCommissionResponse,
} from '/src/api';
import type { ReferralCommission } from '/src/lib/models';

export class ReferralCommissionService {
  /**
   * Get Referral Commission
   * @param id Referral commission ID
   * @returns ReferralCommission
   * @throws ApiError
   */
  public static getReferralCommission({ id }: TGetReferralCommissionRequest): CancelablePromise<ReferralCommission> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/referralCommissionRates/{id}',
      path: { id },
    });
  }

  /**
   * Create Referral Commission
   * @param req Create referral commission request
   * @returns ReferralCommission
   * @throws ApiError
   */
  public static createReferralCommission(
    req: TCreateReferralCommissionRequest
  ): CancelablePromise<TGetReferralCommissionResponse> {
    const { client_id, ...requestBody } = req;
    return __request(OpenAPI, {
      method: 'POST',
      url: `/clients/${client_id}/referralCommissionRates`,
      body: requestBody,
    });
  }
}
